<template>
  <user-item :user="subscriber.follower">
    <template #desktop-actions>
      <a-button
        :title="$translate('profile.actions.profileDetail')"
        className="anz-btn anz-btn-border anz-btn-s anz-btn-border-hover-primary anz-text-nowrap"
        add-href
        :href="generateProfileRoute(subscriber.follower)"
      />
    </template>
    <template #mobile-actions>
      <a-button
        :title="$translate('profile.actions.profileDetail')"
        className="anz-btn anz-btn-primary anz-wf anz-mb-l anz-text-nowrap"
        add-href
        :href="generateProfileRoute(subscriber.follower)"
      />
    </template>
  </user-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import { useRouter } from '@/routing/router'
import UserItem from '@/components/Profile/Lists/Single/UserItem.vue'

export default defineComponent({
  name: 'FollowerUserItem',
  emits: ['removed'],
  components: {
    UserItem,
    AButton,
  },
  props: {
    subscriber: {
      type: Object,
      default: {},
    },
  },
  setup() {
    return {
      ...useRouter(),
    }
  },
})
</script>
